import { render, staticRenderFns } from "./MaterialStatus.vue?vue&type=template&id=72b55e06&scoped=true&lang=pug&"
import script from "./MaterialStatus.vue?vue&type=script&lang=js&"
export * from "./MaterialStatus.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStatus.vue?vue&type=style&index=0&id=72b55e06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b55e06",
  null
  
)

export default component.exports